import { localStorageNamespace } from '@syconium/iron-figs'

export const getLSKey = (key: string) => `${localStorageNamespace}${key}`
